import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable , throwError, Subject } from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {CommonService} from './common.service';
import {PageNotificationService} from './page-notification';
import {RestUrlsConfig} from '@signature-it/ngx-generic/config';

@Injectable({
    providedIn: 'root'
})
export class BookmarksService extends CommonService {
    protected bookmarkAdded = new Subject<any>();
    bookmarkAdded$: any;
    protected baseUrl = `${this.restUrlsConf.appURL}/bookmarks`;

    constructor(protected http: HttpClient,
                protected restUrlsConf: RestUrlsConfig,
                protected notifySvc: PageNotificationService) {
        super(http, restUrlsConf, notifySvc);
        this.bookmarkAdded$ = this.bookmarkAdded.asObservable();
    }

    getAll(): Observable<any> {
        return this.http.get(`${this.baseUrl}/all`)
            .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
    }

    getByPath(path: string): Observable<any> {
        const getByPathUrl = `${this.baseUrl}/getByPath?url=${path}`;
        return this.http.get(getByPathUrl)
            .pipe(map((res) => res), catchError( (error: any) => throwError(error)));
    }

    create(data): Observable<number> {
        return this.http.post<number>(this.baseUrl, JSON.stringify(data))
            .pipe(map((res) => {
                this.bookmarkAdded.next(res);
                return res;
            }), catchError( (error: any) => throwError(error)));
    }

    update(id, data): Observable<number> {
        const updateUrl = `${this.baseUrl}/${id}`;
        return this.http.post<number>(updateUrl, JSON.stringify(data))
            .pipe(map((res) => {
                this.bookmarkAdded.next(res);
                return res;
            }), catchError( (error: any) => throwError(error)));
    }

    remove(id): Observable<number> {
        const removeUrl = `${this.baseUrl}/remove/${id}`;
        return this.http.post<number>(removeUrl, '')
            .pipe(map((res) => {
                this.bookmarkAdded.next(res);
                return res;
            }), catchError( (error: any) => throwError(error)));
    }

}
